export function pick(obj, ...props) {
    const ret = {};
    for (const prop of props)
        if (obj[prop] != null)
            ret[prop] = obj[prop];
    return ret;
}
